var map = {
	"./main/typeshed.en copy.json": [
		6760,
		760
	],
	"./main/typeshed.en.json": [
		6907,
		907
	],
	"./main/typeshed.es-es.json": [
		1779,
		779
	],
	"./main/typeshed.fr.json": [
		1376,
		376
	],
	"./main/typeshed.ja.json": [
		3937,
		937
	],
	"./main/typeshed.ko.json": [
		1870,
		870
	],
	"./main/typeshed.nl.json": [
		4974,
		974
	],
	"./main/typeshed.zh-cn copy.json": [
		3869,
		869
	],
	"./main/typeshed.zh-cn.json": [
		8884,
		884
	],
	"./main/typeshed.zh-tw.json": [
		2420,
		420
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1895;
module.exports = webpackAsyncContext;